import React from "react";
import { StatusSearch } from "./StatusSearch";
import { useSidebar } from "../../widgets/sidebar/SidebarContext";
import { Card, CardContainer, CardHeader, CardTitle, CardWrapper, LayoutWraper } from "../style";

const CaseStatusLayout: React.FC = () => {
    const { sidebar } = useSidebar();
    return (
        <LayoutWraper sidebarOpen={sidebar}>
            <CardWrapper>
                <Card>
                    <CardContainer>
                        <CardHeader>
                            <CardTitle>СТАТУС ПОДНЕТОГ ЗАХТЕВА</CardTitle>
                        </CardHeader>
                        <StatusSearch />
                    </CardContainer>
                </Card>
            </CardWrapper>
        </LayoutWraper>
    );
};

export default CaseStatusLayout;
